import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,0h0.5v0.5h-0.5zM1.5,0h0.5v0.5h-0.5z' },
    {
      paint: 'silo',
      d: 'M-2,-7h1v0.5h-1zM1.5,-7h0.5v1h-0.5zM-2,-6.5h0.5v0.5h-0.5zM-0.5,-6.5h1v0.5h-1zM-2,-6h1v0.5h-1zM-0.5,-6h2v0.5h-2zM-2,-5.5h0.5v1.5h-0.5zM-0.5,-5.5h1v0.5h-1zM1,-5.5h1v0.5h-1zM-0.5,-5h2.5v0.5h-2.5zM-0.5,-4.5h1v0.5h-1zM1,-4.5h1v0.5h-1zM-2,-4h1v0.5h-1zM-0.5,-4h2v0.5h-2zM-2,-3.5h0.5v1.5h-0.5zM-0.5,-3.5h1v0.5h-1zM1.5,-3.5h0.5v0.5h-0.5zM-0.5,-3h2.5v0.5h-2.5zM-0.5,-2.5h1v0.5h-1zM1,-2.5h0.5v1h-0.5zM-2,-2h1v0.5h-1zM-2,-1.5h0.5v1.5h-0.5zM1.5,-1.5h0.5v0.5h-0.5zM-1,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.22],
        ['silo', 0.78],
      ],
      d: 'M1,-7h0.5v0.5h-0.5zM0.5,-6.5h1v0.5h-1zM1.5,-6h0.5v0.5h-0.5zM0.5,-5.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM1.5,-4h0.5v0.5h-0.5zM0.5,-3.5h1v0.5h-1zM0.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v1h-0.5zM-0.5,-2h1.5v0.5h-1.5zM0.5,-1.5h1v0.5h-1zM0.5,-1h1.5v1h-1.5zM0.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['silo', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1.5,-6.5h1v0.5h-1zM-1,-6h0.5v0.5h-0.5zM-1.5,-5.5h1v1.5h-1zM-1,-4h0.5v0.5h-0.5zM-1.5,-3.5h1v1.5h-1zM-1,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v1.5h-1z',
    },
    { paint: 'roofA', d: 'M0,-8.5h0.5v1h-0.5zM-0.5,-7.5h1v0.5h-1z' },
    {
      paint: [
        ['roofA', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-0.5,-9h0.5v0.5h-0.5zM-1,-8.5h1v0.5h-1zM-1.5,-8h1.5v0.5h-1.5zM-2,-7.5h1.5v0.5h-1.5zM-1,-7h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M0,-9h0.5v0.5h-0.5zM0.5,-8.5h0.5v0.5h-0.5zM0.5,-8h1v0.5h-1zM0.5,-7.5h1.5v0.5h-1.5zM0.5,-7h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-0.5,-1.5h1v2h-1z' },
  ],
  pixels: 139,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
